import styled, { css, keyframes } from "styled-components";

const drawLetter = keyframes`
  0% {
    stroke-dashoffset: var(--path-length);
    stroke-width: 2;
  }
  50% {
    stroke-width: 5;
  }
  100% {
    stroke-dashoffset: 0;
    stroke-width: 4;
  }
`;

export const StyledPath = styled.path<{ duration: number; delay: number }>`
  ${({ duration, delay, pathLength }) => css`
    --path-length: ${pathLength}px;
    animation: ${drawLetter} ${duration}s cubic-bezier(0.25, 0.1, 0.25, 1)
      ${delay}s forwards;
  `}
`;
